/* eslint-disable import/no-anonymous-default-export */
import Negocio from '../services/Negocio'

const getOrdenesLogic = async (page, perPage, paremeters, businessModueId, estadoPago, ordenId, search) => {
    const dataResp = await Negocio.getOrdenesService(page, perPage, paremeters, businessModueId, estadoPago, ordenId, search)
    return dataResp
}

const getOrdenesPendientesEnvioLogic = async (page, perPage, paremeters, businessModueId, ordenId, search) => {
    const dataResp = await Negocio.getOrdenesPendientesEnvioService(page, perPage, paremeters, businessModueId, ordenId, search)
    return dataResp
}

const saveComprobantePagoLogic = async (parameters, businessModuleId, ordenId, file, fechaPago) => {
    const dataResp = await Negocio.saveComprobantePagoService(parameters, businessModuleId, ordenId, file, fechaPago)
    return dataResp
}

const saveOrdenConfirmLogic = async (parameters, businessModuleId, ordenId, type, fechaPago) => {
    const dataResp = await Negocio.saveOrdenConfirmLogicService(parameters, businessModuleId, ordenId, type, fechaPago)
    return dataResp
}

const saveChangeTrackingLogic = async (userToken, moduleId, trackId, nuevoEstado, orderId) => {
    const dataResp = await Negocio.saveChangeTrackingService(userToken, moduleId, trackId, nuevoEstado, orderId)
    return dataResp
}

export default {
    getOrdenesLogic,
    saveComprobantePagoLogic,
    saveOrdenConfirmLogic,
    getOrdenesPendientesEnvioLogic,
    saveChangeTrackingLogic
}
